import React, { createContext, useContext, useState, useEffect } from "react";
import { isAuthenticated, clearToken } from "../utils/manageStore";
import { useNavigate, useLocation, Link } from 'react-router-dom';

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const storedValue = localStorage.getItem('user');
    return storedValue ? JSON.parse(storedValue) : null; // Replace 'null' with the initial state value you prefer
  });

  const [timeSlots, setTimeSlots] = useState([]);
  const [slotUnitWidth, setSlotUnitWidth] = useState(0);
  useEffect(() => {
    localStorage.setItem('user', JSON.stringify(user));
  }, [user]);

  const [dateChange, setDateChange] = useState();

  // RO CONFIRM
  const [isROConfirmationModalVisible, setIsROConfirmationModalVisible] = useState(false);
  const [isROCompletionConfirmed, setIsROCompletionConfirmed] = useState();
  const [completedTaskId, setCompletedTaskId] = useState(0);
  const [isROReload, setIsROReload] = useState(false);
  

  const login = (userData) => {
    setUser(userData);
  };

  const handleLogout = () => {
    setUser("");
    clearToken();
  };

  const getToken = () => {
   return isAuthenticated();
  };


  const manageTimeSlots = (slots) =>{
    setTimeSlots(slots)
  }

  const manageSlotUnitWidth = (width) =>{
    setSlotUnitWidth(width)
  }


  return (
    <AuthContext.Provider value={{ user,setUser, login, handleLogout, getToken, manageTimeSlots, timeSlots, manageSlotUnitWidth, slotUnitWidth, dateChange, setDateChange, isROConfirmationModalVisible, setIsROConfirmationModalVisible, isROCompletionConfirmed, setIsROCompletionConfirmed,
      completedTaskId, setCompletedTaskId, isROReload, setIsROReload
     }}>
      {children}
    </AuthContext.Provider>
  );
};

export { AuthContext, AuthProvider };

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
